<template>
  <div id="modalBatchRoleGroup" class="modal fade">
    <div class="modal-dialog modal-sm" role="document">
      <div class="modal-content bd-0 tx-14">
        <div class="modal-header pd-x-20">
          <h6 class="tx-14 mg-b-0 tx-uppercase tx-inverse tx-bold">
            {{ $t("subuser.加入角色组") }}
          </h6>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body pd-20">
          <form>
            <div class="form-group row">
              <label
                for="iptPosition"
                class="
                  col-md-4 col-sm-12 col-form-label
                  form-control-sm
                  text-right
                "
                >{{ $t("subuser.加入角色组：") }}</label
              >
              <div class="col-md-8 col-sm-12">
                <select
                  class="form-control form-control-sm"
                  name="group"
                  v-model="roleId"
                >
                  <option v-for="item in list" :key="item.id" :value="item.id">
                    {{ item.name }}
                  </option>
                </select>
              </div>
            </div>
          </form>
        </div>
        <div class="modal-footer justify-content-center">
          <button
            type="button"
            class="
              btn btn-primary
              tx-11 tx-uppercase
              pd-y-12 pd-x-25
              tx-mont tx-semibold
            "
            @click="subAddGroup()"
          >
            {{ $t("subuser.保存") }}
          </button>
          <button
            type="button"
            class="
              btn btn-secondary
              tx-11 tx-uppercase
              pd-y-12 pd-x-25
              tx-mont tx-semibold
            "
            data-dismiss="modal"
          >
            {{ $t("subuser.关闭") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      roleId: "",
    };
  },
  methods: {
    subAddGroup() {
      let ids = this.$parent.checkArr.join(",");
      let param = {
        ids: ids,
        roleId: this.roleId,
      };
      let vm = this;
      $.api_call("api.SubUser.changeByUser", param, function (r) {
        if (r.ErrorCode == "9999") {
          $("#modalBatchRoleGroup").modal("hide");
          ShowTip(vm.$t("distributor.加入组成功"), "success");
          vm.$parent.checkArr = [];
          vm.$parent.getSubuserList(); //保存完成取一次数据
        } else {
          if (r.ErrorCode == "1002") {
            userFailure(vm);
          } else {
            ShowTip(r.Message, "danger");
          }
        }
      });
    },
  },
};
</script>